import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// @/views
const ContactUs = () => import('@/views/ContactUs.vue');
const FAQ = () => import('@/views/FAQ.vue');
const MediaEnquiries = () => import('@/views/MediaEnquiries.vue');
const Pricing = () => import('@/views/Pricing.vue');
const Services = () => import('@/views/Services.vue');
const AboutUs = () => import('@/views/AboutUs.vue');
const Careers = () => import('@/views/Careers.vue');
const PageNotFound = () => import('@/views/PageNotFound.vue');
const Thanks = () => import('@/views/Thanks.vue');
const Accreditations = () => import('@/views/Accreditations.vue');
// @/views/Disclaimers
const Accessibility = () => import('@/views/Disclaimers/Accessibility.vue');
const Privacy = () => import('@/views/Disclaimers/Privacy.vue');
const TermsOfUse = () => import('@/views/Disclaimers/TermsOfUse.vue');
const Complaints = () => import('@/views/Disclaimers/Complaints.vue');
// @/views/Help

// @/views/Home
const Home = () => import('@/views/Home.vue');
const ClientGateway = () => import('@/views/ClientGateway.vue');
const CustomerPortal = () => import('@/views/CustomerPortal.vue');

const OnlineTools = () => import('@/views/OnlineTools.vue');
const KeySectors = () => import('@/views/KeySectors.vue');
// @/views/CommercialDebt
const CommercialDebt = () => import('@/views/CommercialDebt/CommercialDebt.vue');
const CommercialDebtRecovery = () => import('@/views/CommercialDebt/CommercialDebtRecovery.vue');
const ComplexAndDefendedLitigation = () => import('@/views/CommercialDebt/ComplexAndDefendedLitigation.vue');
const LateStageCollectionsAndIssuingClaims = () => import('@/views/CommercialDebt/LateStageCollectionsAndIssuingClaims.vue');
const RecoveriesThroughInsolvencyLitigation = () => import('@/views/CommercialDebt/RecoveriesThroughInsolvencyLitigation.vue');
// @/views/ConsumerDebt
const ConsumerDebt = () => import('@/views/ConsumerDebt/ConsumerDebt.vue');
const RecoveryAndLitigation = () => import('@/views/ConsumerDebt/RecoveryAndLitigation.vue');
const FullOutsourceSolutions = () => import('@/views/ConsumerDebt/FullOutsourceSolutions.vue');


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'BW Legal is the UK’s largest independent debt recovery law firm. We are focussed on delivering market-leading recovery rates to clients in both the consumer and commercial sectors.'
        }
      ],
      title: 'BW Legal Business'
    }
  },
  {
    path: '/home',
    redirect: { path: '/' }
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'BW Legal is the UK’s largest independent debt recovery law firm. We help businesses with debt recovery and litigation across a broad range of industry sectors. We believe that every business is unique and we tailor our services to meet the specific needs of each client. Our aim is to provide an affordable, ethical and fair service that works for you.'
        }
      ],
      title: 'About us'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'At BW legal, we understand that debt recovery can be an extremely stressful time for businesses. That’s why we offer a personalised, end to end process to fit your needs. We cover a broad range of industry sectors, so whatever your needs are, we’ll be there to help you every step of the way.'
        }
      ],
      title: 'Services'
    }
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'Send us a message and someone from our business team will get back to you as soon as possible.'
        }
      ],
      title: 'Contact us'
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
    meta: {
      title: 'FAQ'
    }
  },  
  {
    path: '/media-enquiries',
    name: 'MediaEnquiries',
    component: MediaEnquiries,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'Send us a message and someone from our business team will get back to you as soon as possible.'
        }
      ],
      title: 'Media enquiries'
    }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: {
      breadCrumb: 'Pricing',
      title: 'Pricing',
      description: 'Our pricing structures are always competitive and, for the majority of debt recovery work we carry out, we look to work contingently with clients.'
    },
  },
  {
    path: '/careers/',
    redirect: { name: 'Careers' }
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'Life at BW Legal is engaging and supportive and we ensure that all colleagues are trained, recognised and rewarded equally. Every colleague is provided with the bespoke development and support they need to thrive and accomplish their career potential and we aim to build a sense of belonging for everyone who works here.'
        }
      ],
      title: 'Careers'
    }
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: 'Page not found'
    }
  },
  {
    path: '/thanks',
    name: 'Thanks',
    component: Thanks,
    meta: {
      title: 'Thanks'
    }
  },
  {
    path: '/accreditations',
    name: 'Accreditations',
    component: Accreditations,
    meta: {
      title: 'Accreditations'
    }
  },
  {
    path: '/accessibility',
    name: 'Accessibility',
    component: Accessibility,
    meta: {
      title: 'Accessibility'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: 'Privacy & Cookies'
    }
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse,
    meta: {
      title: 'Terms of use'
    }
  },
  {
    path: '/complaints',
    name: 'Complaints',
    component: Complaints,
    meta: {
      title: 'Complaints'
    }
  },  
  {
    path: '/commercial-debt',
    name: 'CommercialDebt',
    component: CommercialDebt,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'We can help in the recovery of commercial debt. This is a type of business debt that arises when one company owes money to another for unpaid services or goods or failure to perform obligations under a contract.'
        }
      ],
      breadCrumb: 'Commercial debt',
      title: 'Commercial debt'
    },
    children: [
      {
        path: 'commercial-debt-recovery',
        name: 'CommercialDebtRecovery',
        component: CommercialDebtRecovery,
        meta: {
          breadCrumb: 'Commercial debt recovery',
          title: 'Commercial debt recovery'
        },
      },
      {
        path: 'complex-and-defended-litigation',
        name: 'ComplexAndDefendedLitigation',
        component: ComplexAndDefendedLitigation,
        meta: {
          breadCrumb: 'Complex and defended litigation',
          title: 'Complex and defended litigation',
        },
      },
      {
        path: 'late-stage-collections-and-issuing-claims',
        name: 'LateStageCollectionsAndIssuingClaims',
        component: LateStageCollectionsAndIssuingClaims,
        meta: {
          breadCrumb: 'Late stage collections and issuing claims',
          title: 'Late stage collections and issuing claims'
        },
      },
      {
        path: 'recoveries-through-insolvency-litigation',
        name: 'RecoveriesThroughInsolvencyLitigation',
        component: RecoveriesThroughInsolvencyLitigation,
        meta: {
          breadCrumb: 'Recoveries through insolvency litigation',
          title: 'Recoveries through insolvency litigation'
        },
      }
    ]
  },
  {
    path: '/consumer-debt',
    name: 'ConsumerDebt',
    component: ConsumerDebt,
    meta: {
      metaTags: [
        {
          name: 'description',
          content: 'We can help with the recovery of consumer debt, this is a type of personal debt usually connected with the purchase of goods that are consumable and/or do not appreciate. Examples of consumer debt include: overdrafts, personal loans, store card debt, credit card debt, catalogue debt, hire purchase debt and car finance debt.'
        }
      ],
      breadCrumb: 'Consumer debt',
      title: 'Consumer debt'
    },
    children: [
      {
        path: 'recovery-and-litigation',
        name: 'RecoveryAndLitigation',
        meta: {
          breadCrumb: 'Recovery and litigation',
          title: 'Recovery and litigation'
        },
        component: RecoveryAndLitigation,
      },
      {
        path: 'full-outsource-solutions',
        name: 'FullOutsourceSolutions',
        meta: {
          breadCrumb: 'Full outsource solutions',
          title: 'Full outsource solutions'
        },
        component: FullOutsourceSolutions,
      },
    ]
  },
  {
    path: '/customer-site',
    name: 'CustomerSite',
    beforeEnter() {
      window.open('https://www.bwlegal.co.uk', '_parent');
    }
  },
  {
    path: '/online-tools',
    name: 'OnlineTools',
    component: OnlineTools,
    meta: {
      breadCrumb: 'Online tools',
      title: 'Online tools'
    },
  },
  {
    path: '/key-sectors',
    name: 'KeySectors',
    component: KeySectors,
    meta: {
      breadCrumb: 'Key Sectors',
      title: 'Key Sectors'
    },
  },
  {
    path: '/client-gateway',
    name: 'ClientGateway',
    component: ClientGateway,
    meta: {
      breadCrumb: 'Client Gateway',
      title: 'Client Gateway'
    },
  },
  {
    path: '/customer-portal',
    name: 'CustomerPortal',
    component: CustomerPortal,
    meta: {
      breadCrumb: 'Customer Portal',
      title: 'Customer Portal'
    },
  },
  {
    path: '*',
    redirect: { name: 'PageNotFound' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0, behavior: 'smooth' }
  }
});


router.beforeEach((to, from, next) => {

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const pageTitle = to.path !== '/' ? ' - BW Legal Business' : '';
  window.document.title = to.meta && to.meta.title ? to.meta.title + pageTitle : '';

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  const link = document.createElement('link');

  link.rel = "canonical";
  link.href = `https://www.bwlegal-business.co.uk${to.path}`;
  link.setAttribute('data-vue-router-controlled', '');
  document.getElementsByTagName('head')[0].appendChild(link);

  next();
});

export default router;